
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as guZQ7Wlk_TkvKOmvTwu3HXJgwZQBpwBg35ELlXY6ZkdYMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexG9F_rVq41dz_451znmtv7F9fSeM_Cy7UctX3R0aGf3NFcMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchiSd3hOvH5xCGCYnQQXilBToGcPtcvcj2hT0Tv2lOiTcMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexrwH4IzKHJhGzKN7CYJjiH_45nJ_XJkpbBnfrJQkLkNEXkMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93Y83sAZfhhRFC8WadcHOBtPvfvVXacUbOjWxGiZD4lp0Meta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexRcqQiopGVJ575_45Zso6joNA5NVYrnPUf_j610ZCfm3hkMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Cf5lmGl3gMTa5c33aNfOD41Pjm2BOFDYcPM8QPM04qEMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexDPIrimH_m8IzNLX75dLZhslB5qPVtxTaiG5fcYELmTQMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93n1hd0NwkLlmpS_45FsqV1An2_45aAn2GEH2fT4_odLvpEVkMeta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index3_45yC9A68HoWDWb6I0G3hXjlNdoQb2dV6NTOZumn9f68Meta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexHI2LyJauLx7NbUcOw4tcKedLsNoq0FW7q1jjzq8F2_454Meta } from "/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexRcqQiopGVJ575_45Zso6joNA5NVYrnPUf_j610ZCfm3hkMeta || {},
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexDPIrimH_m8IzNLX75dLZhslB5qPVtxTaiG5fcYELmTQMeta || {},
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index3_45yC9A68HoWDWb6I0G3hXjlNdoQb2dV6NTOZumn9f68Meta || {},
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexHI2LyJauLx7NbUcOw4tcKedLsNoq0FW7q1jjzq8F2_454Meta || {},
    component: () => import("/codebuild/output/src3365466223/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]